<template>
  <v-menu
    ref="menu"
    v-model="isMenuVisible"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="350px"
    @input="openPicker"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedDateTime"
        :label="computedLabel"
        placeholder="DD/MM/YYYY HH:MM"
        persistent-placeholder
        :hide-details="hideDetails"
        :outlined="outlined"
        :dense="dense"
        :prepend-inner-icon="prependInnerIcon"
        readonly
        v-on="on"
        v-bind="attrs"
        class="ac__dtp-field"
      />
      <div v-if="showUnix" class="ac__unix">
        unix: <b>{{ value }}</b>
      </div>
    </template>

    <v-card>
      <v-tabs v-model="activeTab" fixed-tabs>
        <v-tab><v-icon>mdi-calendar-month</v-icon></v-tab>
        <v-tab><v-icon>mdi-clock-outline</v-icon></v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab" class="ac__tab-content">
        <v-tab-item>
          <v-date-picker
            v-model="date"
            class="ac__date-picker"
            width="300px"
            @input="onDateSelect"
          />
        </v-tab-item>
        <v-tab-item>
          <v-time-picker
            v-model="time"
            class="ac__time-picker"
            format="24hr"
            width="300px"
            @input="onTimeSelect"
          />
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="savePicker">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: Number, //Unix timestamp (in sec)
    label: {
      type: String,
      default: "Launch Time"
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    prependInnerIcon: {
      type: String,
      default: null
    },
    showUnix: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isMenuVisible: false,
      activeTab: 0,
      date: null,
      time: "00:00",
    };
  },

  computed: {
    formattedDateTime() {
      return this.value && this.value !== 0
        ? moment.utc(this.value, "X").format("DD/MM/YYYY HH:mm")
        : "";
    },
    computedLabel() {
      return `${this.label} (UTC +0)`;
    }
  },

  watch: {
    value(newVal) {
      this.initDateTime(newVal);
    }
  },

  methods: {
    initDateTime(value) {
      const isEmpty = !value || value === 0;

      if (isEmpty) {
        const now = moment.utc();

        this.date = now.format("YYYY-MM-DD");
        this.time = "00:00";
      } else {
        const dateTime = moment.utc(value, "X");

        this.date = dateTime.format("YYYY-MM-DD");
        this.time = dateTime.format("HH:mm");
      }

      this.activeTab = 0;
    },
    openPicker(isOpen) {
      this.isMenuVisible = isOpen;

      if (!isOpen) return;

      if (!this.value) {
        this.initDateTime(null);
      }
    },
    onDateSelect(value) {
      this.date = value;
      this.activeTab = 1;
    },
    onTimeSelect(value) {
      this.time = value;
    },
    savePicker() {
      if (this.date && this.time) {
        const combinedDateTime = moment.utc(`${this.date} ${this.time}`, "YYYY-MM-DD HH:mm");

        this.$emit("input", combinedDateTime.unix());
      }

      this.isMenuVisible = false;
    }
  },

  mounted() {
    this.initDateTime(this.value);
  },
};
</script>

<style scoped lang="scss">
.ac {
  &__tab-content {
    height: 400px;
  }

  &__unix {
    font-size: 12px;
  }

  &__dtp-field {
    ::v-deep(.v-text-field__slot) {
      input::placeholder {
        font-size: 13px;
      }
    }
  }

  &__date-picker,
  &__time-picker {
    ::v-deep(.v-picker__title) {
      border-top-left-radius: 0 !important;
      border-top-right-radius: 0 !important;
    }
  }

  &__time-picker {
    ::v-deep(.v-picker__title) {
      max-height: 88px;
    }

    ::v-deep(.v-time-picker-title) {
      justify-content: center;
    }

    ::v-deep(.v-picker__title__btn),
    ::v-deep(.v-picker__title__btn + span) {
      height: auto;
      font-size: 50px;
    }
  }
}
</style>